import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=b779479e&scoped=true"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"
import style0 from "./Stages.vue?vue&type=style&index=0&id=b779479e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b779479e",
  null
  
)

export default component.exports